import React, { memo } from 'react';
import { Navigate } from 'react-router-dom';

interface LoadingScreenProps {
  message: string;
}

// Memoize to prevent unnecessary re-renders during loading state transitions
export default memo(function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4 max-w-md px-6">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 mb-2">
          <svg className="w-8 h-8 text-blue-500 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </div>
        <div className="flex flex-col items-center text-center">
          <p className="text-gray-600 text-sm">{message}</p>
        </div>
      </div>
    </div>
  );
}, (prevProps, nextProps) => 
  prevProps.message === nextProps.message
);
